exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background: #044591;\n}\n\n.react-countdown-clock {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-self: center;\n          align-self: center;\n  margin: 0 auto;\n  margin-top: 20px;\n  margin-bottom: 5px;\n}", ""]);

// exports
